package app.model

import kotlinx.serialization.Serializable

@Serializable
data class Company(
    val id: Int,
    val name: String,
)
